const GUID = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
const TIP_ASSET_MD = new RegExp(`!\\[([^\\]]*)\\]\\(tip-asset:(${GUID})\\)`, 'g');
const ASSET_URL_MD = new RegExp(`!\\[([^\\]]*)\\]\\(([^)\\s]*/assets/(${GUID}))\\)`, 'g');

export function publicDashboardTipAssetUrl(id: string): string {
  return `/api/dashboard/tips/assets/${id}`;
}

export function clientPortalAdminTipAssetUrl(id: string): string {
  return `/api/admin/client-portal/dashboard-tips/assets/${id}`;
}

/** Rewrite stored `tip-asset:{id}` image refs to a site-specific fetch URL. */
export function tipAssetMarkdownToDisplay(markdown: string, assetUrl: (id: string) => string): string {
  return (markdown ?? '').replace(TIP_ASSET_MD, (_all, alt: string, id: string) => `![${alt}](${assetUrl(id)})`);
}

/** Persist image URLs that point at `/assets/{guid}` as site-neutral `tip-asset:{id}`. */
export function tipAssetMarkdownToPersist(markdown: string): string {
  return (markdown ?? '').replace(ASSET_URL_MD, '![$1](tip-asset:$3)');
}
